import config from "src/config";
import http from "../services/apiServices";

export const getMaintenanceRequestsApi = async (filterData:any) => {
  return await http.post(config.Case.retrieveMaintenanceRequests,filterData);
};


export const retrieveMaintenanceRequestByTicketNumberApi = async (ticketNumber:string) => {
 return await http.get(config.Case.retrieveMaintenanceRequestByTicketNumber,
    {
      params: {
        TicketNumber:ticketNumber,
      },
    }
  );
};
export const retrieveMaintenanceStatusForEditAPI = async () => {
  return await http.get(config.Case.retrieveMaintenanceStatusForEdit);
};